import object from '@mailobj-browser/front/js/utils/object.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import { helpers } from '#components/generics/js/styles.js'
import * as selector from './tools.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const container = closest(`.${helpers.dateSelector.elements.container}`, button)
    const { dataset } = container
    const { view, today, currentDay, activeDay } = dataset
    let time = today * 86400 * 1000

    if (activeDay) {
      time = activeDay * 86400 * 1000
    }

    if (currentDay) {
      time = currentDay * 86400 * 1000
    }

    const date = new Date(time)

    selector.toggleView(container)
    selector.setCurrentDay(container, date)

    if (view === 'days') {
      selector.setMonths(container, date)
    } else if (view === 'months') {
      selector.setYears(container)
    }
  }
})

export default button => {
  onClick.listen(button)
}
